import * as coed from "@eeue56/coed";

import { HtmlNode, Event, Attribute, Program, RunningProgram, Tag } from "@eeue56/coed";

export { HtmlNode };
export { Event };
export { Attribute };
export { Program };
export { RunningProgram };

export { text };

export { on };
export { onInput };
export { onClick };

export { program };

export { a };
export { abbr };
export { address };
export { area };
export { article };
export { aside };
export { audio };
export { b };
export { base };
export { bdi };
export { bdo };
export { blockquote };
export { body };
export { br };
export { button };
export { canvas };
export { caption };
export { cite };
export { code };
export { col };
export { colgroup };
export { data };
export { datalist };
export { dd };
export { del };
export { details };
export { dfn };
export { dialog };
export { div };
export { dl };
export { dt };
export { em };
export { embed };
export { fieldset };
export { figure };
export { footer };
export { form };
export { h1 };
export { h2 };
export { h3 };
export { h4 };
export { h5 };
export { h6 };
export { head };
export { header };
export { hgroup };
export { hr };
export { html };
export { i };
export { iframe };
export { img };
export { input };
export { ins };
export { kbd };
export { keygen };
export { label };
export { legend };
export { li };
export { link };
export { main };
export { map_ };
export { mark };
export { menu };
export { menuitem };
export { meta };
export { meter };
export { nav };
export { noscript };
export { object };
export { ol };
export { optgroup };
export { option };
export { output };
export { p };
export { param };
export { pre };
export { progress };
export { q };
export { rb };
export { rp };
export { rt };
export { rtc };
export { ruby };
export { s };
export { samp };
export { script };
export { section };
export { select };
export { small };
export { source };
export { span };
export { strong };
export { style };
export { sub };
export { summary };
export { sup };
export { table };
export { tbody };
export { td };
export { template };
export { textarea };
export { tfoot };
export { th };
export { thead };
export { time };
export { title };
export { tr };
export { track };
export { u };
export { ul };
export { var_ };
export { video };
export { wbr };

export { map };

export { class_ };
export { style_ };
export { attribute };
export { none };

export { node };
export { render };

function text<msg>(str: string): HtmlNode<msg> {
    return coed.text(str);
}

function node<msg>(tag: Tag, events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.node(tag, events, attributes, children);
}

function map<a, b>(fn: (arg0: a) => b, node: HtmlNode<a>): HtmlNode<b> {
    return coed.map(fn, node);
}

function program<model, msg>(p: Program<model, msg>): RunningProgram<model, msg> {
    return coed.program(p);
}

function render<a>(node: HtmlNode<a>): string {
    return coed.render(node);
}

function on<msg>(name: string, tagger: (arg0: any) => msg): Event<msg> {
    return coed.on(name, tagger);
}

function onInput<msg>(fn: (arg0: string) => msg): Event<msg> {
    return coed.onInput(fn);
}

function onClick<msg>(fn: (arg0: void) => msg): Event<msg> {
    return on("click", fn);
}

function class_(name: string): Attribute {
    return coed.class_(name);
}

function style_(name: string, value: string): Attribute {
    return coed.style_(name, value);
}

const none: Attribute = coed.none();

function attribute(name: string, value: string): Attribute {
    return coed.attribute(name, value);
}

function a<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.a(events, attributes, children);
}

function abbr<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.abbr(events, attributes, children);
}

function address<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.address(events, attributes, children);
}

function area<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.area(events, attributes);
}

function article<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.article(events, attributes, children);
}

function aside<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.aside(events, attributes, children);
}

function audio<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.audio(events, attributes, children);
}

function b<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.b(events, attributes, children);
}

function base<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.base(events, attributes);
}

function bdi<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.bdi(events, attributes, children);
}

function bdo<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.bdo(events, attributes, children);
}

function blockquote<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.blockquote(events, attributes, children);
}

function body<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.body(events, attributes, children);
}

function br<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.br(events, attributes);
}

function button<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.button(events, attributes, children);
}

function canvas<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.canvas(events, attributes, children);
}

function caption<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.caption(events, attributes, children);
}

function cite<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.cite(events, attributes, children);
}

function code<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.code(events, attributes, children);
}

function col<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.col(events, attributes);
}

function colgroup<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.colgroup(events, attributes, children);
}

function data<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.data(events, attributes, children);
}

function datalist<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.datalist(events, attributes, children);
}

function dd<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.dd(events, attributes, children);
}

function del<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.del(events, attributes, children);
}

function details<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.details(events, attributes, children);
}

function dfn<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.dfn(events, attributes, children);
}

function dialog<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.dialog(events, attributes, children);
}

function div<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.div(events, attributes, children);
}

function dl<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.dl(events, attributes, children);
}

function dt<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.dt(events, attributes, children);
}

function em<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.em(events, attributes, children);
}

function embed<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.embed(events, attributes);
}

function fieldset<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.fieldset(events, attributes, children);
}

function figure<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.figure(events, attributes, children);
}

function footer<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.footer(events, attributes, children);
}

function form<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.form(events, attributes, children);
}

function h1<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.h1(events, attributes, children);
}

function h2<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.h2(events, attributes, children);
}

function h3<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.h3(events, attributes, children);
}

function h4<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.h4(events, attributes, children);
}

function h5<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.h5(events, attributes, children);
}

function h6<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.h6(events, attributes, children);
}

function head<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.head(events, attributes, children);
}

function header<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.header(events, attributes, children);
}

function hgroup<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.hgroup(events, attributes, children);
}

function hr<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.hr(events, attributes);
}

function html<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.html(events, attributes, children);
}

function i<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.i(events, attributes, children);
}

function iframe<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.iframe(events, attributes, children);
}

function img<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.img(events, attributes);
}

function input<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.input(events, attributes);
}

function ins<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.ins(events, attributes, children);
}

function kbd<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.kbd(events, attributes, children);
}

function keygen<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.keygen(events, attributes, children);
}

function label<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.label(events, attributes, children);
}

function legend<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.legend(events, attributes, children);
}

function li<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.li(events, attributes, children);
}

function link<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.link(events, attributes);
}

function main<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.main(events, attributes, children);
}

function map_<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.map_(events, attributes, children);
}

function mark<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.mark(events, attributes, children);
}

function menu<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.menu(events, attributes, children);
}

function menuitem<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.menuitem(events, attributes, children);
}

function meta<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.meta(events, attributes);
}

function meter<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.meter(events, attributes, children);
}

function nav<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.nav(events, attributes, children);
}

function noscript<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.noscript(events, attributes, children);
}

function object<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.object(events, attributes, children);
}

function ol<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.ol(events, attributes, children);
}

function optgroup<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.optgroup(events, attributes, children);
}

function option<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.option(events, attributes, children);
}

function output<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.output(events, attributes, children);
}

function p<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.p(events, attributes, children);
}

function param<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.param(events, attributes);
}

function pre<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.pre(events, attributes, children);
}

function progress<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.progress(events, attributes, children);
}

function q<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.q(events, attributes, children);
}

function rb<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.rb(events, attributes, children);
}

function rp<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.rp(events, attributes, children);
}

function rt<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.rt(events, attributes, children);
}

function rtc<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.rtc(events, attributes, children);
}

function ruby<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.ruby(events, attributes, children);
}

function s<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.s(events, attributes, children);
}

function samp<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.samp(events, attributes, children);
}

function script<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.script(events, attributes, children);
}

function section<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.section(events, attributes, children);
}

function select<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.select(events, attributes, children);
}

function small<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.small(events, attributes, children);
}

function source<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.source(events, attributes);
}

function span<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.span(events, attributes, children);
}

function strong<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.strong(events, attributes, children);
}

function style<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.style(events, attributes, children);
}

function sub<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.sub(events, attributes, children);
}

function summary<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.summary(events, attributes, children);
}

function sup<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.sup(events, attributes, children);
}

function table<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.table(events, attributes, children);
}

function tbody<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.tbody(events, attributes, children);
}

function td<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.td(events, attributes, children);
}

function template<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.template(events, attributes, children);
}

function textarea<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.textarea(events, attributes, children);
}

function tfoot<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.tfoot(events, attributes, children);
}

function th<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.th(events, attributes, children);
}

function thead<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.thead(events, attributes, children);
}

function time<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.time(events, attributes, children);
}

function title<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.title(events, attributes, children);
}

function tr<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.tr(events, attributes, children);
}

function track<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.track(events, attributes);
}

function u<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.u(events, attributes, children);
}

function ul<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.ul(events, attributes, children);
}

function var_<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.var_(events, attributes, children);
}

function video<msg>(events: Event<msg>[], attributes: Attribute[], children: HtmlNode<msg>[]): HtmlNode<msg> {
    return coed.video(events, attributes, children);
}

function wbr<msg>(events: Event<msg>[], attributes: Attribute[]): HtmlNode<msg> {
    return coed.wbr(events, attributes);
}
